export default __webpack_public_path__ + "static/media/section-plane.1ef488f5.jpg";